import React from 'react';
export function PainSection() {
  return <section className="bg-gray-50 py-4 md:py-5 px-4" data-id="element-278">
      <div className="max-w-3xl mx-auto" data-id="element-279">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2 text-center" data-id="element-280">
          ❌ ¿Te pasa esto?
        </h2>

        <div className="space-y-2 text-lg text-gray-700" data-id="element-281">
          <div className="bg-white p-3 rounded-lg shadow-sm border-l-4 border-red-400" data-id="element-282">
            <p className="font-medium" data-id="element-283">
              <span className="font-bold text-red-500 mr-1" data-id="element-284">❌</span>
              Buscás material de educación financiera y encontrás cosas de
              España o México que no sirven para Argentina
            </p>
          </div>

          <div className="bg-white p-3 rounded-lg shadow-sm border-l-4 border-red-400" data-id="element-285">
            <p className="font-medium" data-id="element-286">
              <span className="font-bold text-red-500 mr-1" data-id="element-287">❌</span>
              Armás actividades desde cero porque no existe nada adaptado a la
              realidad argentina de 2026
            </p>
          </div>

          <div className="bg-white p-3 rounded-lg shadow-sm border-l-4 border-red-400" data-id="element-288">
            <p className="font-medium" data-id="element-289">
              <span className="font-bold text-red-500 mr-1" data-id="element-290">❌</span>
              Tus alumnos preguntan "¿para qué me sirve esto?" y no tenés un
              ejemplo local que los enganche
            </p>
          </div>

          <div className="bg-white p-3 rounded-lg shadow-sm border-l-4 border-red-400" data-id="element-291">
            <p className="font-medium" data-id="element-292">
              <span className="font-bold text-red-500 mr-1" data-id="element-293">❌</span>
              Las planificaciones y rúbricas te consumen horas que no tenés
            </p>
          </div>

          <div className="bg-white p-3 rounded-lg shadow-sm border-l-4 border-red-400" data-id="element-294">
            <p className="font-medium" data-id="element-295">
              <span className="font-bold text-red-500 mr-1" data-id="element-296">❌</span>
              Querés hablar de Mercado Pago, inflación y estafas digitales pero
              no tenés el material estructurado
            </p>
          </div>
        </div>
      </div>
    </section>;
}